import { render, staticRenderFns } from "./resignation-modal.vue?vue&type=template&id=9ed4acec&scoped=true"
import script from "./resignation-modal.vue?vue&type=script&lang=js"
export * from "./resignation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed4acec",
  null
  
)

export default component.exports